import UiDetail from "./UiDetail";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import { EnumPipe } from "@/models/EnumPipe";
import UiGroup from "./UiGroup";

/**
 * 开票税率详细
 * @description 自动生成的代码,请勿修改
 */
export default class DtoDetailParamInvoiceTaxRate extends UiDetail<string> {
    constructor() {
        //无参构造函数
        super()
        this.Name = 0;
    }

    [proName: string]: any;
    /**
     * 发票种类
     */
    Type?: string;
    /**
     * 税率
     */
    Name?: number;
    /**
     * 全名
     */
    FullName?: string;
}

/**
 * 开票税率详细-表单校验
 */
export const DtoDetailParamInvoiceTaxRateRules = {
}

/**
 * 开票税率详细-设置项
 */
export const DtoDetailParamInvoiceTaxRateMiezzDetailItems: MiezzFormItem[] = [
  {
    Prop: "Type",
    Label: "发票种类",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "Name",
    Label: "税率",
    Customize: true,
  },
  {
    Prop: "FullName",
    Label: "全名",
    Type: EnumMiezzFormItemType.Text,
  },
]
